import { writable } from 'svelte/store';
import { deriveKey, generateSalt, toBase64, fromBase64 } from '../lib/crypto/webcrypto.js';

const SALT_KEY = 'ytcs:vault-salt';
let vaultKey = null;

export const vaultState = writable({
  ready: false,
  hasKey: false,
  salt: null
});

export function initVault() {
  const storedSalt = localStorage.getItem(SALT_KEY);
  if (storedSalt) {
    vaultState.set({ ready: true, hasKey: false, salt: storedSalt });
    return storedSalt;
  }

  const saltBytes = generateSalt();
  const salt = toBase64(saltBytes);
  localStorage.setItem(SALT_KEY, salt);
  vaultState.set({ ready: true, hasKey: false, salt });
  return salt;
}

export async function unlockVault(passphrase) {
  const salt = initVault();
  const key = await deriveKey(passphrase, fromBase64(salt));
  vaultKey = key;
  vaultState.set({ ready: true, hasKey: true, salt });
}

export function lockVault() {
  vaultKey = null;
  vaultState.update((state) => ({ ...state, hasKey: false }));
}

export function getVaultKey() {
  if (!vaultKey) {
    throw new Error('Vault is locked');
  }
  return vaultKey;
}
